module.exports = function(h, row) {
    if (row.limit_sale) {
        return (
            <span
                class={
                    row.remaining_low == true ? 'text-danger' : 'text-success'
                }
            >
                {row.remaining_text}
            </span>
        );
    } else {
        return '-';
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/couponredeem/remaining.jsx